import React, { useMemo } from 'react';
import {
  FaRegistered, FaCheck
} from 'react-icons/fa';
import GenericCrudPage from '../components/GenericCrudPage';

const RegistrationTypePage = () => {
  const crudConfig = {
    baseUrl: process.env.REACT_APP_BASE_URL || '',
    endpoints: {
      fetch: '/master/getRegistrationType',
      save: '/master/saveRegistrationType',
      update: '/master/updateRegistrationType',
      delete: '/master/deleteRegistrationType'
    },
    entityName: 'Registration Type',
    initialFormState: {
      exName: '',
    },
    validateForm: (form) => {
      const errors = {};
      if (!form.exName) errors.exName = 'Registration Type Name is required.';
      return errors;
    }
  };

  const formFields = useMemo(() => [
    { name: 'exName', label: 'Registration Type Name', icon: FaRegistered, required: true },
  ], []);

  const tableColumns = [
    { key: 'exName', label: 'Name', sortable: true },
  ];

  const csvHeaders = [
    { key: 'exName', label: 'Name' },
    { key: 'exIsActive', label: 'Status', render: () => 'Active' }
  ];

  const transformPayload = (form, editId) => {
    return {
      id: editId,
      exName: form.exName,
      exIsActive: 1, // Always set to active (1)
    };
  };

  const transformToForm = (item) => ({
    exName: item.exName || '',
  });

  const getViewFields = (item) => item ? [
    { label: 'Registration Type Name', value: item.exName, icon: FaRegistered },
    { label: 'Status', value: 'Active', icon: FaCheck },
  ] : [];

  return (
    <GenericCrudPage
      title="Registration Type"
      config={crudConfig}
      formFields={formFields}
      tableColumns={tableColumns}
      csvHeaders={csvHeaders}
      csvFilename="registration_types.csv"
      transformPayload={transformPayload}
      transformToForm={transformToForm}
      getViewFields={getViewFields}
      emptyIcon={FaRegistered}
      searchPlaceholder="Search registration types..."
    />
  );
};

export default RegistrationTypePage;
